import { useMemo } from 'react';
import { useAuth } from '@frontegg/react';

import { hasPermission } from '~/shared/utils/permissions';

import type { PermissionCheck } from '~/shared/utils/permissions';

export function usePermission(required: PermissionCheck, mode: 'any' | 'all' = 'any'): boolean {
  const { user } = useAuth();

  const userPermissions = useMemo<string[]>(() => {
    if (!user?.accessToken) return [];
    try {
      // JWT uses base64url encoding; normalize to standard base64 before decoding
      const b64 = user.accessToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(b64));
      return payload.permissions ?? [];
    } catch {
      return [];
    }
  }, [user?.accessToken]);

  return hasPermission(userPermissions, required, mode);
}
